import { Badge, Group, Loader, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { PipelineStatus } from '@/types/vlm'

const IN_PROGRESS_STATUSES: PipelineStatus[] = [
  PipelineStatus.Pending,
  PipelineStatus.Starting
]

type VlmPipelineStatusBadgeProps = {
  status: PipelineStatus | undefined
}

type StatusConfig = {
  color: string
  translationId: string
}

const STATUS_CONFIG: Record<PipelineStatus, StatusConfig> = {
  [PipelineStatus.Pending]: {
    color: 'gray',
    translationId: 'vlm.pipelines.status.pending'
  },
  [PipelineStatus.Starting]: {
    color: 'blue',
    translationId: 'vlm.pipelines.status.starting'
  },
  [PipelineStatus.Running]: {
    color: 'green',
    translationId: 'vlm.pipelines.status.running'
  },
  [PipelineStatus.Degraded]: {
    color: 'orange',
    translationId: 'vlm.pipelines.status.degraded'
  },
  [PipelineStatus.Stopped]: {
    color: 'gray',
    translationId: 'vlm.pipelines.status.stopped'
  },
  [PipelineStatus.Failed]: {
    color: 'red',
    translationId: 'vlm.pipelines.status.failed'
  }
}

export const VlmPipelineStatusBadge = ({
  status
}: VlmPipelineStatusBadgeProps) => {
  if (!status) {
    return (
      <Text size="sm" c="dimmed">
        -
      </Text>
    )
  }

  const config = STATUS_CONFIG[status]

  if (!config) {
    return (
      <Text size="sm" c="dimmed">
        {status}
      </Text>
    )
  }

  return (
    <Group gap={6} wrap="nowrap">
      <Badge size="sm" color={config.color}>
        <FormattedMessage id={config.translationId} />
      </Badge>
      {IN_PROGRESS_STATUSES.includes(status) && (
        <Loader size={12} color={config.color} />
      )}
    </Group>
  )
}
